// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1M32K","rootSmall":"AddTileButton_rootSmall__1ZDMj"};